import {
  CredentialLayoutBox,
  CredentialSearchbar,
  NoItemView,
} from '../../../components';
import React, { useState } from 'react';
import { useProfileCredentials } from '../../../hooks';
import './CredentialViewContent.css';
import { ICredential } from '../../../model';
import { inIframe } from '../../../utils';
import { useTranslation } from 'react-i18next'; // Step 1

interface CredentialViewContentProps {
  username: string;
}

export const CredentialViewContent: React.FC<CredentialViewContentProps> = ({
  username,
}) => {
  const {
    userCredentials,
    userCredentialsLoaded,
    discoverCredentials,
    discoverCredentialsLoaded,
  } = useProfileCredentials(username);
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslation('library'); // Step 2

  return (
    <span>
      <div
        className="ov_panel active"
        data-name="credentials"
        style={{ marginTop: '20px' }}
      >
        <div>
          <div className="form-block-15 w-form">
            <CredentialSearchbar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            ></CredentialSearchbar>
          </div>

          <CredentialLayoutBox
            userCredentials={userCredentials as ICredential[]}
            userCredentialsLoaded={userCredentialsLoaded as boolean}
            discoverCredentials={discoverCredentials as ICredential[]}
            discoverCredentialsLoaded={discoverCredentialsLoaded as boolean}
            searchTerm={searchTerm}
            userName={username}
          ></CredentialLayoutBox>

          {userCredentials?.length === 0 &&
            userCredentialsLoaded &&
            inIframe() && (
              <NoItemView
                displayMessage={t(
                  "{{username}} hasn't earned any credentials yet.",
                  { username }
                )}
                imageUrl={'/images/tools.png'}
                displayPadding={true}
              />
            )}
        </div>
      </div>
    </span>
  );
};
